// import importedAxios, { AxiosError } from 'axios';

// import { store } from '@/redux-store/store';

// export const isNoInternetError = (
//   error?: any
// ): error is AxiosError<any, any> => {
//   return (
//     importedAxios.isAxiosError(error) &&
//     error.message === 'Network Error' &&
//     error.code === 'ERR_NETWORK'
//   );
// };

import importedAxios, { AxiosError } from 'axios';
import { store } from '@/redux-store/store';
import { setNetworkStatus } from '@/redux-store/slices/network-status';
import { NetworkStatus } from '@/constants';

export const isNoInternetError = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error?: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): error is AxiosError<any, any> => {
  return (
    importedAxios.isAxiosError(error) &&
    error.message === 'Network Error' &&
    error.code === 'ERR_NETWORK'
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const updateNetworkStatus = (error?: any) => {
  const currentNetworkState = store.getState().networkStatus.status;
  let desiredStatus;

  if (error) {
    desiredStatus = isNoInternetError(error)
      ? NetworkStatus.INACTIVE
      : NetworkStatus.ACTIVE;
  } else {
    desiredStatus = NetworkStatus.ACTIVE;
  }

  if (currentNetworkState !== desiredStatus) {
    store.dispatch(setNetworkStatus(desiredStatus));
  }
};
